export function stableStringify(obj: Record<string, any>): string {
  try {
    if (obj === null || typeof obj !== 'object') {
      return '';
    } else {
      return JSON.stringify(
        Object.keys(obj)
          .sort()
          .reduce((acc, key) => {
            acc[key] = obj[key];
            return acc;
          }, {} as Record<string, any>)
      );
    }
  } catch (error) {
    console.error('Error in stableStringify:', error);
    return '';
  }
}
